import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-toggle-v2',
  templateUrl: './toggle-v2.component.html',
  styleUrls: ['./toggle-v2.component.scss'],
})
export class ToggleV2Component {
  @Input() checked = false;
  @Input() disabled = false;
  @Output() checkedChange = new EventEmitter<boolean>();

  toggle(): void {
    if (this.disabled) {
      return;
    }
    this.checkedChange.emit(!this.checked);
  }
}
